<template lang="pug">
  .container.grid-lg
    load-manager(:status="status")
      .mt-2(v-if="current")
        .panel
          .panel-header.bg-gray.p-2
            .h4.text-primary OS-m nº #[span.text-bold {{ current.numero }}/{{ current.ano }}] 
            .h5 {{ deepKey(current, 'assunto.descricao') }}
            .h6 {{ deepKey(current, 'assunto.departamento.diretoria.secretaria.sigla') }} - {{ deepKey(current, 'assunto.departamento.diretoria.secretaria.nome') }}
            .abbr {{ deepKey(current, 'assunto.departamento.diretoria.nome') }}
            .text-small {{ deepKey(current, 'assunto.departamento.nome') }}
          .panel-body
            .columns.mt-2.pt-2
              .column.col-12.bg-gray.p-1 Sobre a OS
              .columns.column.col-12.mt-1.align-center
                .column.col-4.mt-1.col-sm-12(v-if="current.cadastro")
                  div zona: #[span.text-bold {{ current.cadastro.zona || '-' }}]
                  div quadra: #[span.text-bold {{ current.cadastro.quadra || '-' }}]
                  div lote: #[span.text-bold {{ current.cadastro.lote || '-' }}]
                .column.col-4.col-sm-12.mt-1
                  div
                    .text-small {{ 'ordem_servico.protocolo_tipo' | tModel }}
                    .text-bold {{ current | enums('ordem_servico.protocolo_tipo') }}
                  div
                    .text-small {{ 'ordem_servico.protocolo_numero' | tModel }}
                    .text-bold {{ current.protocolo_numero }} / {{ current.protocolo_ano }}
                      .abbr(v-if='current.protocolo_data') {{ current.protocolo_data | date('DD/MM/YYYY') }}
                .column.col-4.col-sm-12.mt-1
                  div
                    .text-small {{ 'ordem_servico.situacao' | tModel }}
                    .text-bold {{ current | enums('ordem_servico.situacao') }}
                  div
                    .text-small {{ 'ordem_servico.cadastro' | tModel }}
                    .text-bold {{ current.cadastro ? current.cadastro.numero : '-' }}
                .column.col-6.mt-1(v-if="current.incluido_por")
                  .text-small {{ 'ordem_servico.incluido_por' | tModel }}
                  .text-bold {{ current | enums('ordem_servico.incluido_por') }}
                .column.col-6.mt-1(v-if="current.comentario_situacao")
                  .text-small {{ 'ordem_servico.comentario_situacao' | tModel }}
                  .text-bold {{ current.comentario_situacao.descricao }}
              .columns.column.col-12.mt-2(v-if='current.items && current.items.length')
                .column.col-12.bg-gray.p-1.mt-2 Itens
                .column.col-6.mt-1(v-for='item in current.items')
                  .text-small {{ item.titulo }}
                  div {{ item.valor }}
              .column.col-12.bg-gray.p-1.mt-2 Responsáveis
              .columns.column.col-12.mt-1
                .column.col-6.col-sm-12.mt-1(v-if='current.usuario')
                  div
                    .text-small {{ 'ordem_servico.usuario' | tModel }}
                    .d-flex.align-center.text-bold
                      user-avatar(:user="current.usuario")
                      span.text-ellipsis &nbsp;{{ current.usuario.nome }}
                .column.col-6.col-sm-12.mt-1(v-if='current.usuario_responsavel')
                  div
                    .text-small {{ 'ordem_servico.usuario_responsavel' | tModel }}
                    .d-flex.align-center.text-bold(v-if="current.usuario_responsavel")
                      user-avatar(:user="current.usuario_responsavel")
                      span.text-ellipsis &nbsp;{{ current.usuario_responsavel.nome }}
                    span(v-else) -

              .column.col-12.bg-gray.p-1.mt-2 Datas
              .columns.column.col-12.mt-1.align-center
                .column.col-3.col-sm-12.mt-1
                  div
                    .text-small {{ 'ordem_servico.created_at' | tModel }}
                    .text-bold {{ current.created_at | date }}
                .column.col-3.col-sm-12.mt-1
                  div
                    .text-small {{ 'ordem_servico.fiscal_ciente_em' | tModel }}
                    .text-bold {{ current.fiscal_ciente_em | date }}
                .column.col-3.col-sm-12.mt-1
                  div
                    .text-small {{ 'ordem_servico.concluir_em' | tModel }}
                    .text-bold {{ current.concluir_em | date }}
                .column.col-3.col-sm-12.mt-1
                  div
                    .text-small {{ 'ordem_servico.concluido_em' | tModel }}
                    .text-bold {{ current.concluido_em | date }}
              .column.col-12.bg-gray.p-1.mt-2 {{ 'ordem_servico.obs' | tModel }}
              .columns.column.col-12.mt-1
                .column.col-12 {{ current.obs || '-' }}

              .column.col-12.columns(v-if="current.fotos && current.fotos.length")
                .column.col-12.bg-gray.p-1.mt-2 {{ 'ordem_servico.fotos' | tModel }}
                .columns.column.col-12
                  .column.col-12
                    .columns.col-oneline.mt-1.images(v-viewer="imageOptions")
                      .column.col-2.col-md-4.col-sm-6.col-xs-12(v-for="foto in current.fotos" :key="foto.id" v-viewer)
                        img.img-responsive(:src="foto.thumb" :data-src="foto.url")

            .mt-2(v-if='current.comentarios && current.comentarios.length')
              .bg-gray.p-1.mt-2 {{ 'ordem_servico.comentarios' | tModel }}
              .tile.pt-2(v-for="comentario in current.comentarios" :key="comentario.id")
                .tile-icon
                  user-avatar(:user="comentario.usuario")
                .tile-content
                  .tile-title {{ comentario.usuario.nome }}
                  .tile-subtitle {{ comentario.descricao }}
                  .text-small {{ comentario.created_at | date }}
                  .text-small(v-if='comentario.comentario_situacao') {{ comentario.comentario_situacao.descricao }}

          .panel-footer
            .text-right
              a.btn.btn-link(:href="current.url" target="_blank")
                btn-content(name="print")
</template>

<script>
import showMixin, { vuexDefaultMapping } from '@/mixins/show'
import { deepKey } from 'paliari-js-utils'

export default {
  vuex: {
    'compartilhado/servicos': vuexDefaultMapping,
  },
  data() {
    return { editing: false, maintenancing: false }
  },
  methods: {
    deepKey,
  },
  mixins: [showMixin],
}
</script>
